/** Save a blob response as a file; prefers the server's filename. */
export const downloadBlob = (blob, fallbackName, contentDisposition) => {
  const m = /filename="?([^";]+)"?/.exec(contentDisposition || "");
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = (m && m[1]) || fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};
